const CURRENCY_SYMBOLS = {
  USD: "$",
  INR: "₹",
  AED: "د.إ",
  EUR: "€",
  GBP: "£",
};

export const currencySymbol = (code) => CURRENCY_SYMBOLS[code] || (code ? `${code} ` : "$");

export const fmtMoney = (amount, currency = "USD", maxFrac = 0) => {
  if (amount === null || amount === undefined || isNaN(amount)) return "—";
  const sym = currencySymbol(currency);
  const n = Number(amount).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: maxFrac,
  });
  return `${sym}${n}`;
};

export const fmtCompact = (amount, currency = "USD") => {
  if (amount === null || amount === undefined || isNaN(amount)) return "—";
  const sym = currencySymbol(currency);
  const abs = Math.abs(amount);
  let s;
  if (abs >= 1_000_000) s = `${(amount / 1_000_000).toFixed(2)}M`;
  else if (abs >= 1_000) s = `${(amount / 1_000).toFixed(1)}K`;
  else s = `${amount.toFixed(0)}`;
  return `${sym}${s}`;
};

export const fmtPct = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return `${Number(n).toFixed(1)}%`;
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" });
  } catch {
    return iso;
  }
};
